import { useEffect } from 'react'

const useThanksPageFailGtmInfo = (transaction_id, shipping_type) => {
    useEffect(() => {
        dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'web_thank_you_page',
            payment_info: 'failed payment',
            payment_type: '',
            shipping_type: shipping_type,
            transaction_id: transaction_id,
            currency: 'CZK',
            value: '',
            coupon: '',
        })
    }, [])
}

export default useThanksPageFailGtmInfo
